'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseIcon } from '../BaseIcon';
export const Search = ({ height = '26px', width = '26px', ...rest }) => {
    return (_jsx(BaseIcon, { height: height, width: width, viewBox: '0 0 26 26', ...rest, children: _jsxs("g", { fill: 'none', fillRule: 'evenodd', stroke: 'currentColor', strokeWidth: '1.5', transform: 'translate(5 5)', children: [_jsx("circle", { cx: '6.39', cy: '6.15', r: '5.88' }), _jsx("path", { d: 'M10.79 10.64l3.36 3.46' })] }) }));
};
//# sourceMappingURL=Search.js.map